import { useEffect } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import useSeo, { ensureJsonLd } from '@/hooks/useSeo';
import Hero from './components/Hero';
import Overview from './components/Overview';
import PlotPreview from './components/PlotPreview';
import CharactersPreview from './components/CharactersPreview';
import Highlights from './components/Highlights';
import EpisodesPreview from './components/EpisodesPreview';
import Testimonials from './components/Testimonials';
import FaqPreview from './components/FaqPreview';

export default function Home() {
  useSeo({
    title: '泡在我家的辣妹 漫画剧情·泡在我家的辣妹漫画介绍',
    description:
      '泡在我家的辣妹漫画剧情到底讲了什么？这里整理泡在我家的辣妹故事主线、设定与分集剧情，帮你快速理清泡在我家的辣妹漫画介绍里的关键情节，看漫画前先搞懂泡在我家的辣妹讲什么。',
    keywords:
      '泡在我家的辣妹,泡在我家的辣妹漫画剧情,泡在我家的辣妹故事,泡在我家的辣妹讲什么,泡在我家的辣妹漫画介绍,泡在我家的辣妹设定,泡在我家的辣妹分集剧情',
    path: '/',
  });

  useEffect(() => {
    ensureJsonLd('ld-website', {
      '@context': 'https://schema.org',
      '@type': 'WebSite',
      name: '泡在我家的辣妹剧情资讯站',
      url: 'https://dramaquest2.github.io/',
      inLanguage: 'zh-CN',
      potentialAction: {
        '@type': 'SearchAction',
        target: 'https://dramaquest2.github.io/search?q={search_term_string}',
        'query-input': 'required name=search_term_string',
      },
    });
    ensureJsonLd('ld-org', {
      '@context': 'https://schema.org',
      '@type': 'Organization',
      name: '泡在我家的辣妹剧情资讯站',
      url: 'https://dramaquest2.github.io/',
      email: 'hello@paojiagal.example.com',
    });
    return () => {
      const list = ['ld-website', 'ld-org'];
      list.forEach((id) => {
        const el = document.getElementById(id);
        if (el) el.remove();
      });
    };
  }, []);

  return (
    <>
      <Navbar />
      <main>
        <Hero />
        <Overview />
        <PlotPreview />
        <CharactersPreview />
        <Highlights />
        <EpisodesPreview />
        <Testimonials />
        <FaqPreview />
      </main>
      <Footer />
    </>
  );
}